$(document).on('click', '.abreFacturaModal', function () {
    var id = this.id.substr(8, 25);
    $("#_method").val("PUT");
    $("#formDocumento").attr('action', "facturas/" + id);
    $("#btnDeleteDocumento").css("display", "block");
    $("#btnDeleteDocumento").attr('onclick', "document.getElementById('delete-" + id + "').submit()");
    $("#nombre-documento").html("Factura");
    $("#label-numero-documento").html("N.Factura:");
    $("#tipo-documento").val("factura");
    $("#container-irpf-documento").show();
    $(".campo").val("");
    $.ajax({
        url: "facturas/" + id,
        type: "GET",
        dataType: "json",
        success: function (data) {
            $("#fichaFacturaLabel").html("Edición de factura");
            //Serial
            $(".num-documento").val(data['serial']);
            //Emisor
            $("#emisor-select-container").addClass("d-none");
            $("#emisor-text-container").removeClass("d-none");
            $("#select-emisor").prop("disabled", true);
            $("#empresa-id").prop("disabled", false);

            if (data['empresa']['logo'] == null) {
                $(".logo-documento img").attr('src', "storage/logo/nologo.jpg");
            } else {
                $(".logo-documento img").attr('src', "storage/" + data['empresa']['logo']);
            }
            $(".nombre-emisor").html(data['empresa']['nombre']);
            $(".cif-emisor").html("NIF: " + data['empresa']['cif']);
            $(".direccion-emisor").html(data['empresa']['direccion']);
            $(".poblacion-emisor").html(data['empresa']['codigo_postal'] + " " + data['empresa']['poblacion']);
            $(".cliente-id").html(data['cliente']['id']);
            $("#cliente-id").val(data['cliente']['id']);
            $("#empresa-id").val(data['empresa']['id']);
            //Receptor
            $(".nombre-receptor").html(data['cliente']['nombre']);
            $(".cif-receptor").html("NIF: " + data['cliente']['cif']);
            $(".direccion-receptor").html(data['cliente']['direccion']);
            $(".poblacion-receptor").html(data['cliente']['codigo_postal'] + " " + data['cliente']['poblacion']);
            //Fecha
            $(".fecha-documento").val(data['fecha_emision']);
            //Observaciones
            $("#observaciones").val(data['observaciones']);
            //Items
            $(".items-documento").empty();
            $(".items-documento").append(`
                <div class="cabecera-items text-center"> 
                    <div class="row g-0 align-items-center w-100">
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Cant</p></div>
                        <div class="col-4 text-start"><p class='m-0 small text-slate-500 fw-bold text-uppercase ps-3'>Concepto</p></div>
                        <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Precio</p></div>
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Dto%</p></div>
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>IVA%</p></div>
                        <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Importe</p></div>
                        <div class="col-1"></div>
                    </div>
                </div>
            `);
            $.each(data['lineas'], function (index, value) {
                $(".items-documento").append(`
                    <div class="registro-items"> 
                        <div class="row g-0 align-items-center w-100">
                            <input name="input_item_id[]" class="d-none input-item-id" type='text' value='`+ value.servicio_id + `'>
                            <div class="col-1">
                                <input name="input_item_cantidad[]" class="form-control text-center fw-bold bg-light input-item-cantidad" type='number' step='0.10' value='`+ value.cantidad + `'>
                            </div>    
                            <div class="col-4">
                                <input type="text" name='input_item_concepto[]' class='form-control fw-semibold input-item-concepto ps-3' value='`+ value.concepto + `'>
                            </div>
                            <div class="col-2">
                                <input name="input_item_precio[]" class="form-control text-end input-item-precio" type='number' step='0.01' value='`+ value.precio + `'>
                            </div>
                            <div class="col-1">
                                <input name="input_item_descuento[]" class="form-control text-center text-slate-400 input-item-descuento" type='number' step='0.01' value='0'>
                            </div>
                            <div class="col-1">
                                <input name="input_item_iva_porcentaje[]" class="form-control text-center text-slate-400 input-item-iva-porcentaje" type='number' step='0.01' value='`+ value.iva_porcentaje + `'>
                                <input type="hidden" name="input_item_iva_importe[]" class="input-item-iva-importe" value="`+ value.iva_importe + `">
                            </div>
                            <div class="col-2">
                                <input type="number" step="0.01" name="input_item_importe[]" class='form-control text-end fw-black text-slate-900 input-item-importe' value='`+ value.total + `'>
                            </div>
                            <div class="col-1 text-center">
                                <a title='Borrar' class='btn btn-link text-danger p-0 borrar-item' href='#'><i class="bi bi-x-circle-fill fs-5"></i></a>
                            </div>
                        </div>
                    </div>
                `);
            });
            $("#irpf-porcentaje-documento").val(data['irpf_porcentaje'] || 15);
            recalculoimporte();
        }
    });
});
$(document).on('click', '.nueva-factura', function () {
    var id = this.id.substr(14, 25);
    $("#_method").val("POST");
    $("#formDocumento").attr('action', "facturas");
    $("#fichaDocumentoLabel").html("Creación de nueva factura");
    $("#btnDeleteDocumento").css("display", "none");
    $(".campo").val("");
    $("#nombre-documento").html("Factura");
    $("#label-numero-documento").html("N.Factura:");
    $("#tipo-documento").val("factura");
    $("#container-irpf-documento").show();
    //Emisor
    $("#emisor-select-container").addClass("d-none");
    $("#emisor-text-container").removeClass("d-none");
    $("#select-emisor").prop("disabled", true);
    $("#empresa-id").prop("disabled", false);

    $.ajax({
        url: "empresa/1",
        type: "GET",
        dataType: "json",
        success: function (data) {
            if (data['logo'] == null) {
                $(".logo-documento img").attr('src', "storage/logo/nologo.jpg");
            } else {
                $(".logo-documento img").attr('src', "storage/" + data['logo']);
            }
            $(".nombre-emisor").html(data['nombre']);
            $(".cif-emisor").html("NIF: " + data['cif']);
            $(".direccion-emisor").html(data['direccion']);
            $(".poblacion-emisor").html(data['codigo_postal'] + " " + data['poblacion']);
            $(".cliente-id").html(id);
            $("#cliente-id").val(id);
            $("#empresa-id").val(1);
        }
    });
    //Receptor
    $.ajax({
        url: "clientes/" + id,
        type: "GET",
        dataType: "json",
        success: function (data) {
            $(".nombre-receptor").html(data['nombre']);
            $(".cif-receptor").html("NIF: " + data['cif']);
            $(".direccion-receptor").html(data['direccion']);
            $(".poblacion-receptor").html(data['codigo_postal'] + " " + data['poblacion']);
        }
    });
    //Fecha
    var fecha = new Date();
    var dia = fecha.getDate();
    var mes = fecha.getMonth() + 1;
    var anyo = fecha.getFullYear();
    $(".fecha-documento").val(anyo + "-" + ("00" + mes).substr(-2, 2) + "-" + ("00" + dia).substr(-2, 2));
    //Items factura
    $(".items-documento").empty();
    $(".items-documento").append(`
        <div class="cabecera-items text-center"> 
            <div class="row g-0 align-items-center w-100">
                <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Cant</p></div>
                <div class="col-4 text-start"><p class='m-0 small text-slate-500 fw-bold text-uppercase ps-3'>Concepto</p></div>
                <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Precio</p></div>
                <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Dto%</p></div>
                <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>IVA%</p></div>
                <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Importe</p></div>
                <div class="col-1"></div>
            </div>
        </div>
    `);
    //Serial
    $.ajax({
        url: "facturas/lastserial",
        type: "GET",
        dataType: "json",
        data: { cliente_id: id },
        success: function (data) {
            console.log(data);
            $(".num-documento").val(data);
        }
    });
});
$(document).on('click', '.historial-facturas', function () {
    var id = this.id.substr(19, 20);
    $.ajax({
        async: false,
        url: "clientes/" + id,
        type: "GET",
        dataType: "json",
        success: function (data) {
            console.log(data);
            $("#historialLabel").html("Historial de facturas de " + data['nombre']);
            $("#historial-lista").empty();
            $("#historial-lista").append(`
                <div class="registro-historial sticky-top"> 
                    <div class='d-flex flex-column w-100'>
                        <div class='d-flex flex-row align-items-center w-100'>
                            <div style='width:2%'>
                                            
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder'># Factura</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder'>Fecha</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder'>Subtotal</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder'>IRPF</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder'>IVA</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder'>Total</p>
                            </div>
                            <div style='width:2%'>
                                    
                            </div>
                        </div>
                    </div>
                </div>
            `);
            $.each(data.facturas, function (index, value) {
                var html = `
                    <div class="registro-historial" id="registro-historal-`+ value['id'] + `"> 
                        <div class='d-flex flex-column w-100'>
                            <div class='d-flex flex-row align-items-center w-100'>
                                <div style='width:2%'>
                                    <i class="bi bi-caret-down-fill desplegable"></i>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1'>`+ value['serial'] + `</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1'><i class="bi bi-calendar-event me-1"></i>`+ value['fecha_emision'] + `</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1'>`+ value['subtotal'] + `€</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1'>`+ value['irpf'] + `€</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1'>`+ value['iva'] + `€</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1'>`+ value['total'] + `€</p>
                                </div>
                                <div style='width:2%'>
                                    <i class="bi bi-eye-fill ver-factura"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                $("#historial-lista").append(html);
                $("#historial-lista").append(`
                    <div class="registro-historial-items registro-historial-items-`+ value['id'] + ` d-none"> 
                        <div class='d-flex flex-column w-100'>
                            <div class='d-flex flex-row align-items-center w-100'>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Cantidad</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Concepto</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Precio</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Descuento</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Total</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
                $.each(value.lineas, function (index2, value2) {
                    var html = `
                        <div class="registro-historial-items registro-historial-items-`+ value['id'] + ` d-none"> 
                            <div class='d-flex flex-column w-100'>
                                <div class='d-flex flex-row align-items-center w-100'>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.cantidad + `ud</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.concepto + `</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.precio + `€</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.descuento + `%</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.total + `€</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                    $("#historial-lista").append(html);
                });
            });
        }
    });
});
$(document).on('click', '.ver-factura', function () {
    var icon = $(this);
    var id = icon.parent().parent().parent().parent().attr('id').substr(18, 100);
    window.open("facturas/imprimir/" + id);
});
$(document).on('click', '.enviar-factura', function () {
    var id = this.id.substr(15, 25);
    Swal.fire({
        title: "¿Estás seguro que deseas enviar por email esta factura?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Enviar",
        denyButtonText: 'No enviar'
    }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire({
                title: 'Enviando factura...',
                text: 'Por favor, espere mientras se genera el PDF y se procesa el envío.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });

            $.ajax({
                url: "facturas/enviar/" + id,
                type: "GET",
                dataType: "json",
                success: function (data) {
                    if (data == true) {
                        Swal.fire("La factura se ha enviado correctamente", "", "success");
                    } else {
                        Swal.fire("La factura no se ha podido enviar", "", "error");
                    }
                },
                error: function (xhr) {
                    let message = "La factura no se ha podido enviar";
                    if (xhr.status === 403 && xhr.responseJSON && xhr.responseJSON.message) {
                        message = xhr.responseJSON.message;
                    }
                    Swal.fire("Error", message, "error");
                }
            });
        } else if (result.isDenied) {
            Swal.fire("La factura no se envió", "", "info");
        }
    });
});
//FUNCIONES
